/* eslint-disable react/jsx-indent */
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import { useState, useEffect } from 'react';

import ProgramList from 'features/Program';
import { ProjectProposalViewList } from 'features/ProjectProposal/pages';
import { ProjectViewList } from 'features/Project/pages';
import { ProjectProposalDefenseStatistics } from 'features/ProjectProposalDefense/pages';

function HomePage() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <LayoutProvider>
      <Layout>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {/* First row: ProgramList (70%) and Statistics (30%) on desktop, stacked on mobile */}
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: 6,
            }}
          >
            <div
              style={{
                flex: isMobile ? '1' : '0 0 70%',
                maxWidth: isMobile ? '100%' : '70%',
              }}
            >
              <ProgramList />
            </div>
            <div
              style={{
                flex: isMobile ? '1' : '0 0 30%',
                maxWidth: isMobile ? '100%' : '30%',
              }}
            >
              <ProjectProposalDefenseStatistics />
            </div>
          </div>

          {/* Second row: Full width components */}
          <div style={{ width: '100%' }}>
            <ProjectProposalViewList />
          </div>
          <div style={{ width: '100%' }}>
            <ProjectViewList />
          </div>
        </div>
      </Layout>
    </LayoutProvider>
  );
}

export default HomePage;
